import { ConnectionItem, Flex, SidePanel, Tag, Text } from "@wayflyer/flyui";
import type { LogoLoadingState } from "bankconnect";
import { useIntl } from "react-intl";

import { BankLogoDisplay } from "../../../../components";
import { MESSAGES } from "../message-definitions";
import type { SelectedAccount } from "../utils";
import { capitalize, getAccountLabel, getConnectedSubtitle } from "../utils";

type AccountDetailsPanelProps = {
  isOpen: boolean;
  selectedAccount: SelectedAccount | null;
  onClose: () => void;
  logoLoadingStates: LogoLoadingState;
};

export const AccountDetailsPanel = ({
  isOpen,
  selectedAccount,
  onClose,
  logoLoadingStates,
}: AccountDetailsPanelProps) => {
  const intl = useIntl();

  if (!selectedAccount) {
    return null;
  }

  const { connection, account } = selectedAccount;

  return (
    <SidePanel open={isOpen} onClose={onClose} title={getAccountLabel(intl, connection, account)} variant="md">
      <Flex direction="column" gap="4">
        <Flex justify="space-between" align="flex-start">
          <Flex gap="3" align="center">
            <Flex direction="column" gap="1">
              <Text fontWeight="semiBold">{account.name}</Text>
              <Text size="sm" color="subtle">
                {account.currency
                  ? intl.formatMessage(MESSAGES.accountDetailsTypeAndCurrency, {
                      accountType: capitalize(account.type),
                      currency: account.currency,
                    })
                  : intl.formatMessage(MESSAGES.accountDetailsType, { accountType: capitalize(account.type) })}
              </Text>
            </Flex>
          </Flex>
          <Tag content={intl.formatMessage(MESSAGES.readyBadge)} color="positive" />
        </Flex>

        <Text size="sm">{intl.formatMessage(MESSAGES.accountDetailsBodyText)}</Text>

        <ConnectionItem
          label={getAccountLabel(intl, connection, account)}
          logo={<BankLogoDisplay logoState={logoLoadingStates[connection.institutionID]} />}
          subtitle={getConnectedSubtitle(intl, connection, account)}
          badgeStatus="positive"
          badgeText={intl.formatMessage(MESSAGES.connectedBadge)}
        />
      </Flex>
    </SidePanel>
  );
};
